module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABWElEQVRIS+3Vz4tOYRQH8M93NJqFLUl2omShFBsrFhZW8icYasx+SvI7wsaGsJoFyiQ2tpr/QFloykopsUZZiI6u7tQ7uHPnffWWxTzbezqfc7+d+9wY88mY+1sHehNeEVFVbcdtHGSk+F5hJsnbZfl34Dn24ha+9463smACs/iS5EAX8AHzSc4N2fxXeVWdwt0kk13Ae3zFhSQLwyBVdQTXsSfJ1GpAE9s2LOFmkoerQVV1FJewH++wtQ+Yx1NcxjG8wQ08SvJjGauq5tl57MMiLmIn7vcBj5PMtZnuxpUW+thO+glXsattfDbJy7b+JO6sGRiYdgeu4Tg24AXmkrwejK+qRgMGoM2YTNJs2x/nn4G+rfovgObVHyQ50zdtR0TTuJdkY9d30GzDZ5zGtyGR5qpoFuFwki1dwCE8w6YRLrtqhzqR5MlfgSEnXlP5+h+tN6axR/QT6G+RGRz1HN0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhengwu/platform_icon_email.png
// module id = VjMN
// module chunks = 1